import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initItemcardGalleryAnimation() {
    const galleryItems = document.querySelectorAll('.itemcardEilaTopGallery__item');

    if (!galleryItems.length) {
        return;
    }

    galleryItems.forEach((item) => {
        gsap.fromTo(item,
            {
                opacity: 0,
                y: 140
            },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: item,
                    start: 'top 85%',
                    toggleActions: 'play none none none',
                    markers: false
                }
            }
        );
    });
}